<template>
  <b-badge v-if="invoice" :id="containerId" pill class="invoice-badge action-links d-inline-flex"
    :class="[{ 'not-paid-for-sales-report': invoice.is_not_paid_for_report, 'over-due': invoice.is_over_due }, invoiceStatusClass]">
    <span v-if="isRouteUpdate && invoice.invoice_number" @click.prevent="pushRoute" style="color: #0052CC;" class="action-link_icon cursor-pointer"
      :id="`edit-btn-${invoice.id}`">
      <span v-html="editIconSvg"></span>
    </span>
    <a class="action-link_icon" v-else href="#" @click.prevent="showEditForm"
      :id="`edit-link-${invoice.id}`">
      <span v-html="editIconSvg"></span>
    </a>
    <a class="ml-1 action-link_icon" :class="{ 'disabled': !invoice.invoice_number }"
      target="_blank" :href="invoice.preview_url" :disabled="!invoice.invoice_number"
      :id="`view-btn-${invoice.id}`">
      <span v-html="draftIconSvg"></span>
    </a>
    <a class="ml-1 action-link_icon" :class="{ 'disabled': !invoice.invoice_number }" :disabled="!invoice.invoice_number" target="_blank"
      @click="!!invoice.worklogs_report_url ? download(invoice.worklogs_report_url) : null"
      :id="`download-btn-${invoice.id}`">
      <span v-html="downloadIconSvg"></span>
    </a>
    <div v-if="invoice.invoice_number" role="group" class="more-actions-dropdown">
      <b-dropdown class="dropdown__theme-light" right variant="link" toggle-class="text-decoration-none" no-caret boundary="viewport">
        <template v-slot:button-content>
          <span class="action-link_icon ml-1" v-html="moreVertIconSvg"></span>
        </template>
        <b-dropdown-item-button @click.prevent="showSendInvoiceEmailModal(invoice)">
          <span class="dropdown-item-link" :class="{ 'active-action-item': !invoice.email_sent_date }">
            <span v-html="mailIconSvg" class="dropdown-icon"></span>
            Send invoice {{ invoice.email_sent_date ? '(sent)' : '' }}
          </span>
        </b-dropdown-item-button>
        <b-dropdown-item-button @click.prevent="markPaidAndReload(invoice)">
          <span class="dropdown-item-link" :class="{ 'active-action-item': !invoice.is_paid }">
            <span v-html="paidIconSvg" class="dropdown-icon"></span>
            Mark as paid {{ !invoice.is_paid ? '' : '(marked)' }}
          </span>
        </b-dropdown-item-button>
        <b-dropdown-item-button @click.prevent="removeInvoice(invoice)">
          <span class="dropdown-item-link" :class="{ 'active-action-item': !invoice.is_paid }">
            <span v-html="removeIconSvg" class="dropdown-icon"></span>
            Remove
          </span>
        </b-dropdown-item-button>
      </b-dropdown>
    </div>

    <!-- Tooltips -->
    <b-tooltip v-if="isRouteUpdate && invoice.invoice_number" :target="`edit-btn-${invoice.id}`"
      :title="'Edit invoice ' + (invoice.invoice_number ? invoice.invoice_number : '')"
      variant="base" container="body" placement="top" boundary="viewport"
      :delay="{ show: 300, hide: 0 }"></b-tooltip>

    <b-tooltip v-if="!isRouteUpdate || !invoice.invoice_number" :target="`edit-link-${invoice.id}`"
      :title="'Edit invoice ' + (invoice.invoice_number ? invoice.invoice_number : '')"
      variant="base" container="body" placement="top" boundary="viewport"
      :delay="{ show: 300, hide: 0 }"></b-tooltip>

    <b-tooltip :target="`view-btn-${invoice.id}`"
      :title="'View invoice ' + (invoice.invoice_number ? invoice.invoice_number : '')"
      variant="base" container="body" placement="top" boundary="viewport"
      :delay="{ show: 300, hide: 0 }"></b-tooltip>

    <b-tooltip :target="`download-btn-${invoice.id}`"
      :title="'Download worklogs report ' + (invoice.invoice_number ? invoice.invoice_number : '')"
      variant="base" container="body" placement="top" boundary="viewport"
      :delay="{ show: 300, hide: 0 }"></b-tooltip>

    <FinanceInvoicesEmailModal v-model="sendEmailModal.show" :title="'test title'" :submitButtonText="'test'"
      :invoiceId="sendEmailModal.invoice ? sendEmailModal.invoice.id : null" :isLoading="getIsModalLoading"
      @submit="invoiceEmailSent" />
  </b-badge>
</template>
<script>

import { cloneDeep } from 'lodash'
import InvoiceFormModal from '../mixins/InvoiceFormModal'
import FinanceInvoicesEmailModal from '@components/modals/FinanceInvoicesEmailModal'
import editIcon from '@/assets/icons/editIcon'
import { draftIconSvg } from '@/assets/icons/draftIcon'
import { downloadIconSvg } from '@/assets/icons/downloadIcon'
import { moreVertIconSvg } from '@/assets/icons/moreVertIcon'
import { mailIconSvg } from '@/assets/icons/mailIcon'
import removeIcon from '@/assets/icons/removeIcon'
import { paidIconSvg } from '@/assets/icons/paidIcon'

export default {
  name: 'InvoicesLinks',
  mixins: [InvoiceFormModal],
  components: {
    FinanceInvoicesEmailModal
  },
  props: {
    templates: {
      type: Array
    },
    item: {
      type: Object,
      default: () => {
      }
    },
    isRouteUpdate: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      invoice: null,
      sendEmailModal: {
        invoice: null,
        show: false
      },
      editIconSvg: editIcon(),
      draftIconSvg,
      downloadIconSvg,
      moreVertIconSvg,
      mailIconSvg,
      removeIconSvg: removeIcon(),
      paidIconSvg
    }
  },
  watch: {
    'item': {
      deep: true,
      immediate: true,
      handler (item) {
        this.invoice = item
      }
    }
  },
  computed: {
    containerId () {
      return `invoices-links-${this.invoice.id}`
    },
    invoiceStatusClass () {
      if (this.invoice.invoice_status.name === 'new') {
        return 'status-new'
      } else if (this.invoice.invoice_status.name === 'sent') {
        return 'status-sent'
      } else if (this.invoice.invoice_status.name === 'paid') {
        return 'status-paid'
      }
      return ''
    }
  },
  methods: {
    pushRoute () {
      const route = this.$router.resolve({
        name: 'finances-invoices-edit',
        params: {
          id: this.invoice.id
        }
      })

      window.history.pushState({}, '', route.href)
      this.showEditForm()
    },
    async removeInvoice (item) {
      if (!item.id) return

      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete the invoice?'
      )

      if (!confirm) return

      this._toggleDataPageLoading(async () => {
        try {
          await this.$api.finances.removeInvoices(item.id)
          this.$snotify.success(
            'Invoice successfully deleted',
            'Success',
            this.$store.state.snotify
          )
        } catch (e) {
          this.$snotify.error(
            'Error on invoice delete',
            'Error',
            this.$store.state.snotify
          )
        }
        this.$emit('deletedInvoice', { data: item.id })
        this.$emit('reloadInvoices')
      })
    },
    markPaidAndReload (invoice) {
      this.$api.finances.markInvoicePaid(invoice.id)
        .then(({ data }) => {
          this.invoice = cloneDeep(data)
          this.$snotify.success(
            'Invoice successfully marked as paid',
            'Success',
            this.$store.state.snotify
          )
          this.$emit('reloadInvoices')
        }, error => {
          this.outputErrorNotification(error)
        })
    },
    showEditForm () {
      this.$emit('showEditForm', this.invoice)
    },
    showSendInvoiceEmailModal (item) {
      this.sendEmailModal.invoice = item
      this.sendEmailModal.show = true
    },
    invoiceEmailSent (invoice) {
      this.invoice = cloneDeep(invoice)
      this.sendEmailModal.show = false
      this.$emit('reloadInvoices')
    },
    download (url) {
      const link = document.createElement('a')
      link.href = url
      link.download = ''
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice-badge {
  font-size: 14px;
  padding: 6px 12px 4px;
  background-color: #DEEBFF;

  a, :global(.btn-link) {
    cursor: pointer;
    color: $iconColorAccent;
  }

  &.action-links {
    background-color: transparent;
  }
}

.invoice-badge {
  gap: 4px;
}

.action-link_icon {
  padding-left: 3px;
  padding-right: 3px;
}

.dropdown-icon {
  width: 18px;
  display: inline-block;
  text-align: center;
  margin-right: 5px;
}

.material-symbols-outlined {
  font-size: 18px;
}

.more-actions-dropdown .material-symbols-outlined {
  color: $iconColorAccent;
  vertical-align: -4px;
  margin-right: 3px;
}

:global(.dropdown__theme-light .dropdown-menu.dropdown-menu-right) {
  width: fit-content !important;
}

.invoice-popover-text {
  font-size: 13px;
}

.template-link {
  text-decoration: none
}

.status-new {
  background-color: #faf0be;
}

.status-new.over-due {
  background-size: 5px 5px !important;
  background-image: linear-gradient(135deg, lightgoldenrodyellow 25%, #ffa07a 0, #ffa07a 50%, lightgoldenrodyellow 0, lightgoldenrodyellow 75%, #ffa07a 0, #ffa07a) !important;
}

.status-sent {
  background-color: #ede742;
}

.status-sent.over-due {
  background-size: 5px 5px !important;
  background-image: linear-gradient(135deg, #ede742 25%, #ffa07a 0, #ffa07a 50%, #ede742 0, #ede742 75%, #ffa07a 0, #ffa07a) !important;
}

.status-paid {
  background-color: #deebff;
}

.active-action-item {
  color: #1a237e;
}
</style>
